<i18n
  src="@/locales/views/customer/query/containers_intermediated/list_processes.yml"
  lang="yaml"
></i18n>
<template>
  <bread-crumbs :labels="[module_name]"></bread-crumbs>

  <div
    v-if="load_data_general"
    class="bg-white shadow overflow-hidden sm:rounded-md mt-8"
  >
    <ul role="list" class="divide-y divide-slate-200">
      <li
        v-for="agro_exporter_process in agro_exporter_processes"
        :key="agro_exporter_process.id"
      >
        <div
          class="block hover:bg-slate-50 cursor-pointer"
          @click.prevent="goToContainers(agro_exporter_process)"
        >
          <div class="px-4 py-4 sm:px-6">
            <div class="flex items-center justify-between">
              <p class="text-sm font-medium text-gray-900 truncate">
                {{ agro_exporter_process.name }}
              </p>
              <div class="ml-2 flex-shrink-0 flex">
                <a class="link invisible sm:visible">
                  <i class="fa-solid fa-eye"></i>
                  <span class="space-icon"></span>{{ $t("labels.show_link") }}
                </a>
              </div>
            </div>
            <div class="mt-2 sm:flex sm:justify-between">
              <div class="sm:flex space-x-0 sm:space-x-6">
                <p class="mt-2 flex items-center text-sm text-gray-500 sm:mt-0">
                  <i
                    class="fa-solid fa-container-storage flex-shrink-0"
                    aria-hidden="true"
                  />
                  <span class="space-icon"></span>
                  {{ agro_exporter_process.number_containers }}
                </p>
              </div>
            </div>
          </div>
        </div>
      </li>
    </ul>
  </div>
  <template v-else>
    <loading-message />
  </template>
</template>

<script>
import Requester from "@/views/customer/requesters/query/containers_intermediated/list_processes.js";

export default {
  name: "ListAgroExporters",
  props: {
    customer_id: { required: true }
  },
  data: function () {
    return {
      load_data_general: false,
      agro_exporter_processes: null
    };
  },
  methods: {
    fetchAgroExportersProcesses: async function () {
      const response = await Requester.fetchAgroExportersProcesses(
        this.customer_id
      );
      this.agro_exporter_processes = response.data;
      this.load_data_general = true;
    },
    goToContainers: function (agro_exporter_process) {
      this.$router.push({
        name: this.routeName("list_containers"),
        params: {
          customer_id: this.customer_id,
          agro_exporter_process_id: agro_exporter_process.id
        }
      });
    }
  },
  created: function () {
    this.checkIfAuthenticated().then(() =>
      this.checkIfAuthorized({
        role: this.$route.meta.role,
        permission: this.$route.meta.permission,
        entity: {
          customer_id: this.customer_id
        }
      }).then(() => this.fetchAgroExportersProcesses())
    );
  }
};
</script>
